import type { RateRepository } from '@/core/rate'
import type { UseCase } from '@/core/shared'

export const getChargerRatesWeekSchedules: UseCase<RateRepository, 'getChargerRatesWeekSchedules'> = repository => {
  return async (chargerUid) => {
    return await repository.getChargerRatesWeekSchedules(chargerUid)
  }
}
